import styled from 'styled-components';

import Button from 'components/ui/Button';

import { colours } from 'themes/default';

export const HotelOnlyContainer = styled.div`
  width: 100%;
  max-width: 1024px;
  margin: auto;
  padding: 25px;
  box-sizing: border-box;
`;

export const StyledHeader = styled.header`
  margin-bottom: 45px;

  h1 {
    margin-bottom: 5px;
  }
`;

export const SubmitButton = styled(Button)`
  height: 40px;
  margin: 0 0 0 8px;
`;

export const StyledFormContainer = styled.div`
  display: flex;
  padding: 1em;
  background-color: ${colours.Shades.TintBlue10};
  margin-bottom: 1rem;
  justify-content: space-between;
`;

export const StyledInputWrapper = styled.div`
  & + & {
    margin-left: 1em;
  }

  input {
    width: auto;
    height: 35px;
    font-size: 13px;

    &:disabled {
      border: 1px solid transparent;
      background: transparent;
      font-weight: bold;
    }
  }
`;

export const StyledLabel = styled.span`
  display: flex;
  width: 100%;
  font-size: 12px;
`;

export const HotelDetailsContainer = styled.div`
  padding: 20px;
  background-color: white;
  box-shadow: rgb(238 238 238) 0px 0px 30px;
`;

export const StyledPrice = styled.div`
  background: aliceblue;
  padding: 8px 16px;
  text-align: right;
`;

export const VerticalLine = styled.div`
  border-right: solid 1px rgb(188, 188, 188);
  padding: 0 16px;
`;

export const StyledHr = styled.hr`
  width: 100%;
  color: rgb(188, 188, 188);
`;

export const StyledErrorMessage = styled.p`
  margin-top: 0;
  width: 100%;
  color: ${colours.Messaging.ErrorRed};
`;
